const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getAccidentReportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ACCIDENT_REPORT_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'ACCIDENT_REPORT_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'ACCIDENT_REPORT_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'ACCIDENT_REPORT_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getAccidentReportReducer;


// WEBPACK FOOTER //
// ./src/reducers/getAccidentReport.js